import { FC } from 'react';
import { AmlHistoryItemData } from '@/redux/models';
import { AmlFlowEnum } from '@/api';
import { AmountInfo, GeneralInfo } from './components';

import styles from './TransactionInfo.module.sass';
import { AmlMistrackInfo } from '../AddressInfo/components';

interface TransactionInfoProps {
  isLoading?: boolean;
  item?: AmlHistoryItemData;
}

const TransactionInfo: FC<TransactionInfoProps> = ({ item, isLoading }) => {
  const hasMistrackData = () => {
    return (
      [
        AmlFlowEnum.ADVANCED,
        AmlFlowEnum.LIGHT,
        AmlFlowEnum.LITE,
        AmlFlowEnum.FAST_LIMITED,
        AmlFlowEnum.ADVANCED_LIMITED,
      ].includes(item?.flow || AmlFlowEnum.ADVANCED) &&
      item?.extras &&
      (!!item?.extras?.tags?.length ||
        !!Object.keys(item?.extras?.services).length)
    );
  };

  const hasAmount = !!item?.amount;

  return (
    <>
      {hasAmount && item?.amountData && (
        <div className={styles.box}>
          <AmountInfo item={item} isLoading={isLoading} />
        </div>
      )}
      <div className={styles.box}>
        <GeneralInfo item={item} isLoading={isLoading} />
      </div>
      {!!hasMistrackData() && (
        <div className={styles.box}>
          <AmlMistrackInfo
            info={item?.extras}
            isLoading={isLoading}
            isTx
            amlFlow={item?.flow}
          />
        </div>
      )}
    </>
  );
};

export default TransactionInfo;
